"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreSonarObjectsSearchSlice = void 0;
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../api/index.js");
const logGetCoreSonarObjectsSearch = (0, sonar_analytics_1.createLogSagaWithFn)((action) => {
    const data = action.data;
    return {
        data: {
            type: data.queryString
        },
        id: sonar_analytics_1.AMPLITUDE_EVENT.SEARCH_MADE
    };
});
exports.getCoreSonarObjectsSearchSlice = (0, xuder_1.createGetAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: logGetCoreSonarObjectsSearch,
            type: xuder_1.SagaYieldType.Every
        }
    ],
    name: 'CoreSonarObjectsSearch',
    receive: true,
    request: true,
    requestHandler: _api_1.getSonarObjectsSearch,
    retainDataOnRequest: true
});
//# sourceMappingURL=get.js.map